import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';
import { mergeRefs } from '@react-aria/utils';
import { InternalSelectionListItem } from './components/SelectionListItem/components/InternalSelectionListItem/InternalSelectionListItem.js';
import { SelectionListLabel } from './components/SelectionListLabel/SelectionListLabel.js';
import { InternalSelectionListSection } from './components/SelectionListSection/components/InternalSelectionListSection.js';
import { SelectionListBoxContext } from './context/SelectionListBoxContext.js';
import { useSelectionListBox } from './hooks/useSelectionListBox.js';

var SelectionListBox = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var selectionMode = props.selectionMode,
    label = props.label;
  var _useSelectionListBox = useSelectionListBox(props),
    state = _useSelectionListBox.state,
    listBoxProps = _useSelectionListBox.listBoxProps,
    listBoxRef = _useSelectionListBox.listBoxRef,
    labelProps = _useSelectionListBox.labelProps;
  var labelElement = label && /*#__PURE__*/React.createElement(SelectionListLabel, {
    label: label,
    labelProps: labelProps
  });
  return /*#__PURE__*/React.createElement(SelectionListBoxContext.Provider, {
    value: {
      selectionMode: selectionMode,
      isVirtualized: false
    }
  }, labelElement, /*#__PURE__*/React.createElement("ul", _extends({}, listBoxProps, {
    ref: mergeRefs(ref, listBoxRef)
  }), _toConsumableArray(state.collection).map(function (item) {
    return item.type === 'section' ? /*#__PURE__*/React.createElement(InternalSelectionListSection, {
      key: item.key,
      section: item,
      state: state
    }) : /*#__PURE__*/React.createElement(InternalSelectionListItem, {
      key: item.key,
      item: item,
      state: state
    });
  })));
}));

export { SelectionListBox };
//# sourceMappingURL=SelectionListBox.js.map
